import React, { useState, useEffect } from 'react';
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Offer = () => {
    const slides = [
        { image: "/offer-img-01.jpg", title: "Baseball Cap", offer: "Up to 30%" },
        { image: "/offer-img-02.jpg", title: "Long Sleeve", offer: "Up to 30%" },
        { image: "/offer-img-03.jpg", title: 'Tote Bags', offer: "Up to 30%" },
        { image: "/offer-img-04.jpg", title: 'Ladies Shirt', offer: "Up to 40%" },
        { image: "/offer-img-05.jpg", title: 'Ladies Watch', offer: "Up to 45%" },
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsPerSlide, setItemsPerSlide] = useState(1);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 640) {
                setItemsPerSlide(1); // mobile
            } else if (width < 1024) {
                setItemsPerSlide(2); // tablet
            } else {
                setItemsPerSlide(3); // desktop
            }
        };

        handleResize(); // set initially
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            (prevIndex + itemsPerSlide) % slides.length
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            (prevIndex - itemsPerSlide + slides.length) % slides.length
        );
    };

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 4000);
        return () => clearInterval(interval);
    }, [itemsPerSlide]);

    const visibleSlides = slides.slice(currentIndex, currentIndex + itemsPerSlide);
    const displaySlides =
        visibleSlides.length < itemsPerSlide
            ? [...visibleSlides, ...slides.slice(0, itemsPerSlide - visibleSlides.length)]
            : visibleSlides;

    return (
        <div className="w-[90%] mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 mt-4 gap-2">
                {displaySlides.map((slide, index) => (
                    <div key={index} className="bg-gray-800 flex align-center justify-center rounded-lg shadow hover:shadow-lg transition mx-4">
                        <img
                            src={slide.image}
                            alt={slide.title}
                            className="h-32 object-contain rounded-md mr-4"
                        />
                        <div className="flex flex-col align-center justify-center">
                            <p className="font-bold text-body text-white truncate">{slide.title}</p>
                            <p className="text-orange-600 text-body truncate">
                                {slide.offer}
                                <FontAwesomeIcon icon={faChevronRight} className="text-white ml-1" />
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Offer;
